__turbopack_context__.v({
  "consumerCardsContainer": "ConsumerCards-module-scss-module__fjktQq__consumerCardsContainer",
});
